import React, { useEffect, useState } from "react";
import "./careerPage.css";
import { useNavigate } from "react-router-dom";
import { JOBS, JobDetail } from "./jobsData";

const PAGE_SIZE = 10;

const CareerPage: React.FC = () => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
    useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // remove if you want instant
    });
  }, []);

  const pageCount = Math.ceil(JOBS.length / PAGE_SIZE);
  const startIndex = (page - 1) * PAGE_SIZE;
  const jobsForPage: JobDetail[] = JOBS.slice(
    startIndex,
    startIndex + PAGE_SIZE
  );

  const goToPage = (p: number) => {
    if (p < 1 || p > pageCount) return;
    setPage(p);
  };

  const handleView = (id: string) => {
    navigate(`/careers/${id}`);
  };

  return (
    <div className="career-root">
      {/* ===== TOP BLUE BAR ===== */}
      <header className="career-header">
        <div className="career-header-inner">
          <h1 className="career-title">Job Listing</h1>
          <p className="career-subtitle">
            Available Openings at Nordic Integration Works
          </p>
        </div>
      </header>

      {/* ===== MAIN CONTENT ===== */}
      <main className="career-main">
        <div className="career-main-inner">
          {/* LEFT COLUMN (text like screenshot) */}
          <section className="career-left">
            <h2 className="career-section-title">
              Current Available Openings
            </h2>
            <div className="career-section-underline" />
            <p className="career-jobs-count">{JOBS.length} Jobs found</p>
          </section>

          {/* RIGHT COLUMN (job list + view buttons + pagination) */}
          <section className="career-right">
            {jobsForPage.map((job) => (
              <article key={job.id} className="career-row">
                <div className="career-job-text">
                  <button type="button" className="career-job-link">
                    {job.title}
                  </button>
                  <span className="career-job-location">
                    {job.location}
                  </span>
                </div>

                <button
                  type="button"
                  className="career-view-btn"
                  onClick={() => handleView(job.id)}
                >
                  View <span className="career-view-arrow">→</span>
                </button>
              </article>
            ))}

            {/* ===== PAGINATION (bottom centre like screenshot) ===== */}
            <div className="career-pagination">
              <button
                type="button"
                className="career-page-arrow"
                onClick={() => goToPage(page - 1)}
                disabled={page === 1}
              >
                ‹
              </button>

              {Array.from({ length: pageCount }).map((_, index) => {
                const p = index + 1;
                return (
                  <button
                    key={p}
                    type="button"
                    className={`career-page-number ${
                      p === page ? "active" : ""
                    }`}
                    onClick={() => goToPage(p)}
                  >
                    {p}
                  </button>
                );
              })}

              <button
                type="button"
                className="career-page-arrow"
                onClick={() => goToPage(page + 1)}
                disabled={page === pageCount}
              >
                ›
              </button>
            </div>
          </section>
        </div>
      </main>

      {/* small spacer so footer doesn't overlap */}
      <div style={{ height: "100px" }} />
    </div>
  );
};

export default CareerPage;
